import { CreditCard, MessageCircle, Users } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { WaConnectionCard, useGateway } from "../components/WaConnection";
import { cn } from "../components/ui";
import Loans from "./Loans";
import Students from "./Students";

const TABS = [
  { id: "siswa", label: "Siswa / Anggota", icon: Users },
  { id: "pinjaman", label: "Akun Pinjaman", icon: CreditCard },
  { id: "wa", label: "Nomor WA Resmi", icon: MessageCircle },
];

function WaTab() {
  const { gw, load } = useGateway();
  return (
    <div className="max-w-2xl space-y-3" data-testid="master-wa-tab">
      <WaConnectionCard gw={gw} reload={load} showNumberEditor />
      <p className="text-xs text-muted-foreground">Mengganti HP/nomor: klik <b>Putuskan / Ganti HP</b>, perbarui nomor terdaftar, lalu scan QR dari HP baru — berlaku langsung tanpa deploy ulang. Percakapan & pengaturan kirim ada di menu <Link to="/whatsapp" className="underline text-primary" data-testid="master-wa-goto">WhatsApp Resmi</Link>.</p>
    </div>
  );
}

export default function MasterData() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? (params.get("tab") as string) : "siswa";
  const go = (t: string) => setParams({ tab: t });
  return (
    <div data-testid="master-data-page">
      <div className="inline-flex rounded-lg border bg-card p-1 mb-5" data-testid="master-tabs">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`master-tab-${t.id}`} onClick={() => go(t.id)} className={cn("inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition-colors", tab === t.id ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground")}>
            <t.icon className="h-4 w-4" /> {t.label}
          </button>
        ))}
      </div>
      {tab === "siswa" ? <Students /> : tab === "pinjaman" ? <Loans /> : <WaTab />}
    </div>
  );
}
